// This file contains the Time zone selector values

// Time zone values
const timeZones = {
  de_DE: [
    {value: 'Africa/Casablanca', label: '(GMT) Casablanca, Monrovia'},
    {value: 'Europe/London', label: '(GMT) Dublin, Edinburgh, Lissabon, London'},
    {value: 'GMT', label: '(GMT) Greenwich Mean Time'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rom, Stockholm, Wien'},
    {value: 'Europe/Prague', label: '(GMT+01:00) Belgrad, Bratislava, Budapest, Ljubljana, Prag'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) Brüssel, Kopenhagen, Madrid, Paris'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Sarajevo, Skopje, Warschau, Zagreb'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) Westliches Zentralafrika'},
    {value: 'Europe/Athens', label: '(GMT+02:00) Athen, Istanbul, Minsk'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) Bukarest'},
    {value: 'Africa/Harare', label: '(GMT+02:00) Harare, Pretoria'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki, Riga, Sofia, Tallinn, Wilna'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalem'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) Kairo'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) Bagdad'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riad'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) Moskau, St. Petersburg, Wolgograd'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) Teheran'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) Abu Dhabi, Muskat'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) Baku, Tiflis, Jerewan'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) Kabul'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karatschi, Taschkent'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) Jekaterinburg'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) Kolkata, Chennai, Mumbai, Neu-Delhi'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) Kathmandu'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) Almaty, Nowosibirsk'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) Astana, Dhaka'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) Sri Jayawardenepura'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) Rangun'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) Hanoi, Jakarta'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnojarsk'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk, Ulaanbataar'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) Kuala Lumpur, Singapur'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) Peking, Chongqing, Hongkong, Ürümqi'},
    {value: 'Australia/Perth', label: '(GMT+08:00) Perth'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) Taipei'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) Jakutsk'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) Osaka, Sapporo, Tokio'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) Seoul'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) Darwin'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) Canberra, Melbourne, Sydney'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) Hobart'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) Wladiwostok'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) Magadan, Salomon-Inseln, Neukaledonien'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) Fidschi, Kamtschatka, Marshallinseln.'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nukualofa'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) Azoren'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Kap Verde'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) Buenos Aires, Georgetown'},
    {value: 'America/St_Johns', label: '(GMT-03:30) Neufundland'},
    {value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time (Kanada)'},
    {value: 'America/Caracas', label: '(GMT-04:00) Caracas, La Paz'},
    {value: 'America/Santiago', label: '(GMT-04:00) Santiago'},
    {value: 'America/Bogota', label: '(GMT-05:00) Bogotá, Lima, Quito'},
    {value: 'America/New_York', label: '(GMT-05:00) Eastern Time (USA und Kanada)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) Indiana (East)'},
    {value: 'America/Chicago', label: '(GMT-06:00) Central Time (USA und Kanada)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) Mexiko-Stadt'},
    {value: 'America/Phoenix', label: '(GMT-07:00) Arizona'},
    {value: 'America/Denver', label: '(GMT-07:00) Mountain Time (USA und Kanada)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time (USA und Kanada), Tijuana'},
    {value: 'America/Anchorage', label: '(GMT-09:00) Alaska'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) Midway-Inseln, Samoa'},
  ],
  en_US: [
    {value: 'Africa/Casablanca', label: '(GMT) Casablanca, Monrovia'},
    {value: 'Europe/London', label: '(GMT) Dublin, Edinburgh, Lisbon, London'},
    {value: 'GMT', label: '(GMT) Greenwich Mean Time'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'},
    {value: 'Europe/Belgrade', label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris'},
    {value: 'Europe/Prague', label: '(GMT+01:00) Prague'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) West Central Africa'},
    {value: 'Europe/Athens', label: '(GMT+02:00) Athens, Istanbul, Minsk'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) Bucharest'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) Cairo'},
    {value: 'Africa/Harare', label: '(GMT+02:00) Harare, Pretoria'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki, Riga, Sofia, Tallinn, Vilnius'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalem'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) Baghdad'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riyadh'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) Tehran'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) Abu Dhabi, Muscat'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) Baku, Tbilisi, Yerevan'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) Kabul'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) Ekaterinburg'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi, Tashkent'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) Calcutta, Chennai, Mumbai, New Delhi'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) Kathmandu'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) Almaty, Novosibirsk'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) Astana, Dhaka'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) Sri Jayawardenepura'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) Rangoon'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) Hanoi, Jakarta'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk, Ulaan Bataar'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) Kuala Lumpur, Singapore'},
    {value: 'Australia/Perth', label: '(GMT+08:00) Perth'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) Taipei'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) Osaka, Sapporo, Tokyo'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) Seoul'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) Darwin'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) Canberra, Melbourne, Sydney'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) Hobart'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nukualofa'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) Azores'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Cape Verde Is.'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) Buenos Aires, Georgetown'},
    {value: 'America/St_Johns', label: '(GMT-03:30) Newfoundland'},
    {value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time (Canada)'},
    {value: 'America/Puerto_Rico', label: '(GMT-04:00) Puerto Rico, ECT'},
    {value: 'America/Santiago', label: '(GMT-04:00) Santiago'},
    {value: 'America/Caracas', label: '(GMT-04:30) Caracas'},
    {value: 'America/Bogota', label: '(GMT-05:00) Bogota, Lima, Quito'},
    {value: 'America/New_York', label: '(GMT-05:00) Eastern Time (US and Canada)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) Indiana (East)'},
    {value: 'America/Chicago', label: '(GMT-06:00) Central Time (US and Canada)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) Mexico City'},
    {value: 'America/Phoenix', label: '(GMT-07:00) Arizona'},
    {value: 'America/Denver', label: '(GMT-07:00) Mountain Time (US and Canada)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time (US and Canada); Tijuana'},
    {value: 'America/Anchorage', label: '(GMT-09:00) Alaska'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) Midway Island, Samoa'},
  ],
  es_ES: [
    {value: 'Africa/Casablanca', label: '(GMT) Casablanca, Monrovia'},
    {value: 'Europe/London', label: '(GMT) Dublín, Edinburgo, Lisboa, Londres'},
    {value: 'GMT', label: '(GMT) Tiempo medio de Greenwich'},
    {value: 'Europe/Prague', label: '(GMT+01:00) Belgrado, Bratislava, Budapest, Liubliana, Praga'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) Bruselas, Copenhage, Madrid, París'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Sarajevo, Skopie, Varsovia, Zagreb'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) África Central Occidental'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) Ámsterdam, Berlín, Berna, Roma, Estocolmo, Viena'},
    {value: 'Europe/Athens', label: '(GMT+02:00) Atenas, Estambul, Minsk'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) Bucarest'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) Cairo'},
    {value: 'Africa/Harare', label: '(GMT+02:00) Harare, Pretoria'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki, Riga, Sofía, Tallin, Vilna'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalén'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) Bagdad'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riad'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) Moscú, San Petersburgo, Volgogrado'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) Teherán'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) Abu Dabi, Mascate'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) Bakú,Tiflis, Ereván'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) Kabul'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) Ekaterimburgo'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi, Taskent'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) Calcuta, Chennai, Bombay, Nueva Delhi'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) Katmandú'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) Almatý, Novosibirsk'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) Astaná, Daca'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) Sri Jayawardanapura'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) Rangún'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) Hanói, Yakarta'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk, Ulán Bator'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) Kuala Lumpur, Singapur'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) Pekín, Chongqing, Hong Kong, Urumchi'},
    {value: 'Australia/Perth', label: '(GMT+08:00) Perth'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) Taipéi'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) Osaka, Sapporo, Tokio'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) Seúl'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaida'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) Darwin'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) Canberra, Melbourne, Sídney'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) Hobart'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) Magadán, Islas Salomón, Nueva Caledonia'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) Fiyi, Kamchatka, Islas Marshall'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nukualofa'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) Azores'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Cabo Verde.'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) Buenos Aires, Georgetown'},
    {value: 'America/St_Johns', label: '(GMT-03:30) Terranova'},
    {value: 'America/Caracas', label: '(GMT-04:00) Caracas, La Paz'},
    {value: 'America/Halifax', label: '(GMT-04:00) Hora del Atlántico (Canadá)'},
    {value: 'America/Santiago', label: '(GMT-04:00) Santiago'},
    {value: 'America/Bogota', label: '(GMT-05:00) Bogotá, Lima, Quito'},
    {value: 'America/New_York', label: '(GMT-05:00) Hora del este (EE.UU. y Canadá)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) Indiana (este)'},
    {value: 'America/Chicago', label: '(GMT-06:00) Hora central (EE.UU. y Canadá)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) México, D.F'},
    {value: 'America/Phoenix', label: '(GMT-07:00) Arizona'},
    {value: 'America/Denver', label: '(GMT-07:00) Hora de la montaña (EE.UU. y Canadá)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) Hora del Pacífico (EE. UU. y Canadá); Tijuana'},
    {value: 'America/Anchorage', label: '(GMT-09:00) Alaska'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawái'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) Islas Midway, Samoa'},
  ],
  fr_FR: [
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Sarajevo, Skoplje, Varsovie, Zagreb - Heure d’Europe centrale'},
    {value: 'Europe/London', label: 'GMT  Dublin, Édimbourg, Lisbonne, Londres - Heure d’Europe de l’Ouest'},
    {value: 'GMT', label: 'GMT - Heure de Greenwich'},
    {value: 'Africa/Casablanca', label: 'GMT Casablanca, Monrovia - Heure d’Europe de l’Ouest'},
    {
      value: 'Africa/Malabo',
      label: 'GMT+01:00  Alger, Douala, Kinshasa, Lagos, Luanda, Malabo - Heure d’Afrique de l’Ouest',
    },
    {value: 'Europe/Brussels', label: 'GMT+01:00  Bruxelles, Copenhague, Madrid, Paris - Heure d’Europe centrale'},
    {
      value: 'Europe/Amsterdam',
      label: 'GMT+01:00 Amsterdam, Berlin, Berne, Rome, Stockholm, Vienne - Heure d’Europe centrale',
    },
    {
      value: 'Europe/Prague',
      label: 'GMT+01:00 Belgrade, Bratislava, Budapest, Ljubljana, Prague - Heure d’Europe centrale',
    },
    {value: 'Europe/Athens', label: 'GMT+02:00  Athènes, Instanbul, Minsk - Heure d’Europe de l’Est'},
    {value: 'Europe/Bucharest', label: 'GMT+02:00  Bucarest - Heure d’Europe de l’Est'},
    {value: 'Europe/Helsinki', label: 'GMT+02:00  Helsinki, Riga, Sofia, Tallinn, Vilnius - Heure d’Europe de l’Est'},
    {value: 'Asia/Jerusalem', label: 'GMT+02:00  Jérusalem - Heure d’Israël'},
    {value: 'Africa/Cairo', label: 'GMT+02:00  Le Caire - Heure d’Europe de l’Est'},
    {value: 'Africa/Harare', label: 'GMT+02:00 Harare, Pretoria'},
    {value: 'Asia/Kuwait', label: 'GMT+0300 Koweït, Riyad'},
    {value: 'Asia/Baghdad', label: 'GMT+03:00  Bagdad'},
    {value: 'Africa/Nairobi', label: 'GMT+03:00  Nairobi - Heure de l’Afrique de l’Est'},
    {value: 'Europe/Moscow', label: 'GMT+03:00 Moscou, St.-Pétersbourg, Volgograd - Heure de Moscou'},
    {value: 'Asia/Tehran', label: 'GMT+03:30  Téhéran - Heure de l’Iran'},
    {value: 'Asia/Muscat', label: 'GMT+0400 Abu Dhabi, Muscat'},
    {value: 'Asia/Tbilisi', label: 'GMT+04:00 Bakou, Tbilisi, Erevan'},
    {value: 'Asia/Kabul', label: 'GMT+04:30  Kaboul - Heure de l’Afghanistan'},
    {value: 'Asia/Yekaterinburg', label: 'GMT+05:00  Ekaterinbourg - Heure d’Ekaterinbourg'},
    {value: 'Asia/Karachi', label: 'GMT+05:00  Islamabad, Karachi, Tachkent'},
    {value: 'Asia/Calcutta', label: 'GMT+05:30  Chennai, Calcutta, Mumbai, New Delhi - Heure de l’Inde'},
    {value: 'Asia/Colombo', label: 'GMT+05:30  Colombo, Sri Jayawardenepura Kotte - Heure du Sri Lanka'},
    {value: 'Asia/Katmandu', label: 'GMT+05:45  Kathmandou - Heure du Népal'},
    {value: 'Asia/Novosibirsk', label: 'GMT+06:00  Almaty, Novosibirsk'},
    {value: 'Asia/Dhaka', label: 'GMT+06:00 Astana, Dacca'},
    {value: 'Asia/Rangoon', label: 'GMT+06:30  Yangon - Heure de Brimanie'},
    {value: 'Asia/Bangkok', label: 'GMT+07:00  Bangkok'},
    {value: 'Asia/Jakarta', label: 'GMT+07:00  Hanoi, Djakarta'},
    {value: 'Asia/Krasnoyarsk', label: 'GMT+07:00  Krasnoyarsk - Heure de Krasnoyarsk'},
    {value: 'Asia/Irkutsk', label: 'GMT+08:00  Irkutsk, Ulan Bator'},
    {value: 'Asia/Singapore', label: 'GMT+08:00  Kuala Lumpur, Singapour'},
    {value: 'Australia/Perth', label: 'GMT+08:00  Perth - Heure standard de l’Ouest-Australie'},
    {value: 'Asia/Taipei', label: 'GMT+08:00  Taipei'},
    {value: 'Asia/Shanghai', label: 'GMT+08:00 Pékin, Chongqoing, Hong Kong, Urumchi'},
    {value: 'Asia/Tokyo', label: 'GMT+09:00  Osaka, Sapporo, Tokyo - Heure standard du Japon'},
    {value: 'Asia/Seoul', label: 'GMT+09:00  Séoul - Heure standard Corée'},
    {value: 'Asia/Yakutsk', label: 'GMT+09:00  Yakutsk - Heure de Yakutsk'},
    {value: 'Australia/Adelaide', label: 'GMT+09:30  Adelaïde - Heure standard du Centre-Australie'},
    {value: 'Australia/Darwin', label: 'GMT+09:30  Darwin - Heure standard du Centre-Australie'},
    {value: 'Australia/Brisbane', label: 'GMT+10:00  Brisbane - Heure standard de l’Est-Australie'},
    {value: 'Australia/Sydney', label: 'GMT+10:00  Canberra, Melbourne, Sydney - Heure standard de l’Est-Australie'},
    {value: 'Pacific/Guam', label: 'GMT+10:00  Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: 'GMT+10:00  Hobart - Heure standard de l’Est-Australie'},
    {value: 'Asia/Vladivostok', label: 'GMT+10:00  Vladivostok - Heure de Vladivostok'},
    {value: 'Asia/Magadan', label: 'GMT+11:00 Magadan, Îles Salomon, Nouvelle-Calédonie'},
    {value: 'Pacific/Auckland', label: 'GMT+12:00  Auckland, Wellington - Heure d’hiver Nouvelle-Zélande'},
    {value: 'Pacific/Fiji', label: 'GMT+12:00  Fidji, Kamchatka, Îles Marshall.'},
    {value: 'Pacific/Tongatapu', label: 'GMT+13:00  Nuku’alofa'},
    {value: 'Atlantic/Azores', label: 'GMT-01:00  Ponta Delgada - Heure des Açores'},
    {value: 'Atlantic/Cape_Verde', label: 'GMT-01:00, Paria, Heure du Cap-Vert.'},
    {value: 'America/Buenos_Aires', label: 'GMT-03:00  Buenos Aires, Georgetown'},
    {value: 'America/Sao_Paulo', label: 'GMT-03:00  São Paulo - Heure de Brasilia'},
    {value: 'America/St_Johns', label: 'GMT-03:30  St. John’s - Heure de Terre-Neuve'},
    {value: 'America/Caracas', label: 'GMT-04:00  Caracas, La Paz'},
    {value: 'America/Halifax', label: 'GMT-04:00  Halifax - Heure de l’Atlantique'},
    {value: 'America/Santiago', label: 'GMT-04:00  Santiago - Heure du Chili'},
    {value: 'America/Bogota', label: 'GMT-05:00  Bogota, Lima, Quito'},
    {value: 'America/Indianapolis', label: 'GMT-05:00  Indiana Est- Heure de l’Est des États-Unis'},
    {value: 'America/New_York', label: 'GMT-05:00  Montréal, New York - Heure de l’Est des États-Unis'},
    {value: 'America/Chicago', label: 'GMT-06:00  Chicago, Winnipeg - Heure du Centre des États-Unis'},
    {value: 'America/Mexico_City', label: 'GMT-06:00 Mexico - Heure du Centre des États-Unis'},
    {value: 'America/Phoenix', label: 'GMT-07:00  Arizona'},
    {value: 'America/Denver', label: 'GMT-07:00  Calgary, Denver - Heure des montagnes Rocheuses'},
    {value: 'America/Los_Angeles', label: 'GMT-08:00  Los Angeles, Tijuana, Vancouver - Heure du Pacifique'},
    {value: 'America/Anchorage', label: 'GMT-09:00  Anchorage - Heure de l’Alaska'},
    {value: 'Pacific/Honolulu', label: 'GMT-10:00  Honolulu - Heure d’Hawaï-Îles Aléoutiennes'},
    {value: 'Pacific/Samoa', label: 'GMT-11:00  Atoll de Midway, Samoa'},
  ],
  it_IT: [
    {value: 'Africa/Casablanca', label: '(GMT) Casablanca, Monrovia'},
    {value: 'Europe/London', label: '(GMT) Dublino, Edimburgo, Lisbona, Londra'},
    {value: 'GMT', label: '(GMT) Tempo medio di Greenwich'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) Africa centro-occidentale'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdam, Berlino, Berna, Roma, Stoccolma, Vienna'},
    {value: 'Europe/Prague', label: '(GMT+01:00) Belgrado, Bratislava, Budapest, Lubiana, Praga'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) Bruxelles, Copenhagen, Madrid, Parigi'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Sarajevo, Skopje, Varsavia, Zagabria'},
    {value: 'Europe/Athens', label: '(GMT+02:00) Atene, Istanbul, Minsk'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) Bucarest'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) Gerusalemme'},
    {value: 'Africa/Harare', label: '(GMT+02:00) Harare, Pretoria'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki, Riga, Sofia, Tallinn, Vilna'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) il Cairo'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) Baghdad'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riyad'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) Mosca, San Pietroburgo, Volgograd'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) Tehran'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) Abu Dhabi, Muscat'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) Baku, Tbilisi, Yerevan'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) Kabul'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) Ekaterinburg'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi, Tashkent'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) Calcutta, Chennai, Mumbai, Nuova Delhi'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) Kathmandu'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) Almaty, Novosibirsk'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) Astana, Dhaka'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) Sri Jayawardenepura'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) Rangoon'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) Hanoi, Giacarta'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk, Ulaan Bataar'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) Kuala Lumpur, Singapore'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) Pechino, Chongqing, Hong Kong, Urumqi'},
    {value: 'Australia/Perth', label: '(GMT+08:00) Perth'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) Taipei'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) Osaka, Sapporo, Tokyo'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) Seoul'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) Darwin'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) Canberra, Melbourne, Sydney'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) Hobart'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) Magadan, Isole Salomone, Nuova Caledonia'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) Figi, Kamchatka, Isole Marshall.'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nuku\'alofa'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) Azzorre'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Capo Verde, Isole.'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) Buenos Aires, Georgetown'},
    {value: 'America/St_Johns', label: '(GMT-03:30) Terranova'},
    {value: 'America/Caracas', label: '(GMT-04:00) Caracas, La Paz'},
    {value: 'America/Halifax', label: '(GMT-04:00) Ora costa atlantica (Canada)'},
    {value: 'America/Santiago', label: '(GMT-04:00) Santiago'},
    {value: 'America/Bogota', label: '(GMT-05:00) Bogotà, Lima, Quito'},
    {value: 'America/New_York', label: '(GMT-05:00) Fuso orientale (USA e Canada)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) Indiana (Est)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) Città del Messico'},
    {value: 'America/Chicago', label: '(GMT-06:00) Fuso centrale (USA e Canada)'},
    {value: 'America/Phoenix', label: '(GMT-07:00) Arizona'},
    {value: 'America/Denver', label: '(GMT-07:00) Fuso occidentale (USA e Canada)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) Pacifico (USA e Canada); Tijuana'},
    {value: 'America/Anchorage', label: '(GMT-09:00) Alaska'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) Isola di Midway, Samoa'},
  ],
  zh_CN: [
    {value: 'Africa/Casablanca', label: '(GMT)卡萨布兰卡，蒙罗维亚'},
    {value: 'GMT', label: '(GMT)格林威治标准时间'},
    {value: 'Europe/London', label: '(GMT)都柏林，爱丁堡，里斯本，伦敦'},
    {value: 'Africa/Malabo', label: '(GMT+01:00)中非西部'},
    {value: 'Europe/Brussels', label: '(GMT+01:00)布鲁塞尔，哥本哈根，马德里，巴黎'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00)萨拉热窝，斯科普里，华沙，萨格勒布'},
    {value: 'Europe/Prague', label: '(GMT+01:00)贝尔格莱德，布拉迪斯拉发，布达佩斯，卢布尔雅那，布拉格'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00)阿姆斯特丹，柏林，伯尔尼，罗马，斯德哥尔摩，维也纳'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) 赫尔辛基，索非亚，维尔纽斯，里加，塔林'},
    {value: 'Africa/Harare', label: '(GMT+02:00)哈拉雷，比勒陀利亚'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00)布加勒斯特'},
    {value: 'Africa/Cairo', label: '(GMT+02:00)开罗'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00)耶路撒冷'},
    {value: 'Europe/Athens', label: '(GMT+02:00)雅典，伊斯坦布尔，明斯克'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00)内罗华'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00)巴格达'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00)科威特，利雅得'},
    {value: 'Europe/Moscow', label: '(GMT+03:00)莫斯科，森彼得堡，伏尔加格勒'},
    {value: 'Asia/Tehran', label: '(GMT+03:30)德黑兰'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00)巴库，第比利斯，埃里温'},
    {value: 'Asia/Muscat', label: '(GMT+04:00)阿布扎比，马斯喀特'},
    {value: 'Asia/Kabul', label: '(GMT+04:30)喀布尔'},
    {value: 'Asia/Karachi', label: '(GMT+05:00)伊斯兰堡，卡拉奇，塔什干'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00)叶卡捷琳堡'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30)加尔各答，马德拉斯，孟买，新德里'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45)加德满都'},
    {value: 'Asia/Colombo', label: '(GMT+06:00)斯里哈亚华登尼普拉'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00)阿拉木图，新西伯利亚'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00)阿斯塔纳，达卡'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30)仰光'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00)克拉斯诺亚尔斯克'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00)曼谷'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00)河内，雅加达'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00)伊尔库茨克，乌兰巴'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00)北京，重庆，香港，乌鲁木齐'},
    {value: 'Asia/Taipei', label: '(GMT+08:00)台北'},
    {value: 'Asia/Singapore', label: '(GMT+08:00)吉隆坡，新加坡'},
    {value: 'Australia/Perth', label: '(GMT+08:00)珀斯'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00))大坂，扎幌，东京'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00)雅库茨克'},
    {value: 'Asia/Seoul', label: '(GMT+09:00)首尔'},
    {value: 'Australia/Darwin', label: '(GMT+09:30)达尔文'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30)阿德莱德'},
    {value: 'Pacific/Guam', label: '(GMT+10:00)关岛，莫尔兹比港'},
    {value: 'Australia/Sydney', label: '(GMT+10:00)堪培拉，墨尔本，悉尼'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00)布里斯班'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00)符拉迪沃斯托克'},
    {value: 'Australia/Hobart', label: '(GMT+10:00)霍巴特'},
    {value: 'Asia/Magadan', label: '(GMT+11:00)马加丹，所罗门群岛，新喀里多尼亚'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00)奥克兰，惠灵顿'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00)斐济，勘察加半岛，马绍尔群岛'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00)努库阿洛法'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00)亚述尔群岛'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00)佛得角群岛'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00)巴西利亚'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00)布宜诺斯艾利斯，乔治敦'},
    {value: 'America/St_Johns', label: '(GMT-03:30)纽芬兰'},
    {value: 'America/Caracas', label: '(GMT-04:00)加拉加斯，拉巴斯'},
    {value: 'America/Santiago', label: '(GMT-04:00)圣地亚哥'},
    {value: 'America/Halifax', label: '(GMT-04:00)大西洋时间(加拿大)'},
    {value: 'America/New_York', label: '(GMT-05:00)东部时间(美国和加拿大)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00)印第安纳(东)'},
    {value: 'America/Bogota', label: '(GMT-05:00)波哥大，利马，基多'},
    {value: 'America/Chicago', label: '(GMT-06:00)中部时间(美国和加拿大)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00)墨西哥城'},
    {value: 'America/Phoenix', label: '(GMT-07:00)亚利桑那州'},
    {value: 'America/Denver', label: '(GMT-07:00)山地时间(美国和加拿大)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00)太平洋时间(美国和加拿大)；蒂华纳'},
    {value: 'America/Anchorage', label: '(GMT-09:00)阿拉斯加州'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00)夏威夷州'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00)中途岛，萨摩亚群岛'},
  ],
  ja_JP: [
    {value: 'Africa/Casablanca', label: '(GMT) カサブランカ, モンロビア'},
    {value: 'Europe/London', label: '(GMT) ダブリン, エジンバラ, リスボン, ロンドン'},
    {value: 'GMT', label: '(GMT) グリニッジ標準時'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) アムステルダム, ベルリン, ベルン, ローマ, ストックホルム, ウィーン'},
    {value: 'Europe/Belgrade', label: '(GMT+01:00) ベオグラード, ブラチスラバ, ブダペスト, リュブリャナ'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) ブリュッセル, コペンハーゲン, マドリード, パリ'},
    {value: 'Europe/Prague', label: '(GMT+01:00) プラハ'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) サラエボ, スコピエ, ソフィア, ビリニュス, ワルシャワ, ザグレブ'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) アフリカ中西部'},
    {value: 'Europe/Athens', label: '(GMT+02:00) アテネ, イスタンブール, ミンスク'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) ブカレスト'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) カイロ'},
    {value: 'Africa/Harare', label: '(GMT+02:00) ハラレ, プレトリア'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) ヘルシンキ, リガ, タリン'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) エレサレム'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) バグダッド'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) クウェート, リヤド'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) モスクワ, サンクトペテルブルク, ボルゴグラード'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) ナイロビ'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) テヘラン'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) アブダビ, マスカット'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) バクー, トビリシ, エレバン'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) カブール'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) エカテリンブルク'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) イスラマバード, カラチ, タシケント'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) コルカタ, チェンナイ, ムンバイ, ニューデリー'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) カトマンズ'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) アルマトイ, ノヴォシビルスク'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) アスタナ, ダッカ'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) スリジャヤワルダナプラコッテ'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) ヤンゴン'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) バンコク'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) ハノイ, ジャカルタ'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) クラスノヤルスク'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) 北京, 重慶, 香港, ウルムチ'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) イルクーツク, ウランバートル'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) クアラルンプール, シンガポール'},
    {value: 'Australia/Perth', label: '(GMT+08:00) パース'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) 台北'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) 大阪, 札幌, 東京'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) ソウル'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) ヤクーツク'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) アデレード'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) ダーウィン'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) ブリスベン'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) キャンベラ, メルボルン, シドニー'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) グアム, ポートモレスビー'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) ホバート'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) ウラジオストク'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) マガダン, ソロモン諸島, ニューカレドニア'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) オークランド, ウェリントン'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) フィジー, カムチャツカ, マーシャル諸島'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) ヌクアロファ'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) アゾレス諸島'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) カーボベルデ'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) ブラジリア'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) ブエノスアイレス, ジョージタウン'},
    {value: 'America/St_Johns', label: '(GMT-03:30) ニューファンドランド州'},
    {value: 'America/Halifax', label: '(GMT-04:00) 大西洋標準時（カナダ）'},
    {value: 'America/Puerto_Rico', label: '(GMT-04:00) プエルトリコ, ECT'},
    {value: 'America/Santiago', label: '(GMT-04:00) サンティアゴ'},
    {value: 'America/Caracas', label: '(GMT-04:30) カラカス'},
    {value: 'America/Bogota', label: '(GMT-05:00) ボゴタ, リマ, キト'},
    {value: 'America/New_York', label: '(GMT-05:00) 東部標準時（米国およびカナダ）'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) インディアナ州（東部）'},
    {value: 'America/Chicago', label: '(GMT-06:00) 中部標準時（米国およびカナダ）'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) メキシコシティ'},
    {value: 'America/Phoenix', label: '(GMT-07:00) アリゾナ州'},
    {value: 'America/Denver', label: '(GMT-07:00) 山地標準時（米国およびカナダ）'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) 太平洋標準時刻（米国およびカナダ）; ティフアナ'},
    {value: 'America/Anchorage', label: '(GMT-09:00) アラスカ州'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) ハワイ州'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) ミッドウェー島, サモア'},
  ],
  ko_KR: [
    {value: 'Africa/Casablanca', label: '(GMT) 카사블랑카, 몬로비아'},
    {value: 'Europe/London', label: '(GMT) 더블린, 에든버러, 리스본, 런던'},
    {value: 'GMT', label: '(GMT) 그리니치 표준시'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) 암스테르담, 베를린, 베른, 로마, 스톡홀름, 비엔나'},
    {value: 'Europe/Belgrade', label: '(GMT+01:00) 베오그라드, 브라티슬라바, 부다페스트, 류블랴나'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) 브뤼셀, 코펜하겐, 마드리드, 파리'},
    {value: 'Europe/Prague', label: '(GMT+01:00) 프라하'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) 사라예보, 스코페, 소피아, 빌뉴스, 바르샤바, 자그레브'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) 서중앙 아프리카'},
    {value: 'Europe/Athens', label: '(GMT+02:00) 아테네, 이스탄불, 민스크'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) 부쿠레슈티'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) 카이로'},
    {value: 'Africa/Harare', label: '(GMT+02:00) 하라레, 프리토리아'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) 헬싱키, 리가, 탈린'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) 예루살렘'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) 바그다드'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) 쿠웨이트, 리야드'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) 모스크바, 상트페테르부르크, 볼고그라드'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) 나이로비'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) 테헤란'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) 아부다비, 무스카트'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) 바쿠, 트빌리시, 예레반'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) 카불'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) 예카테린부르크'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) 이슬라마바드, 카라치, 타슈켄트'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) 캘커타, 첸나이, 뭄바이, 뉴델리'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) 카트만두'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) 알마티, 노보시비르스크'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) 아스타나, 다카'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) 스리자야와르데네푸라'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) 양곤'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) 방콕'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) 하노이, 자카르타'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) 크라스노야르스크'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) 베이징, 충칭, 홍콩, 우루무치'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) 이르쿠츠크, 울란바토르'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) 콸라룸푸르, 싱가포르'},
    {value: 'Australia/Perth', label: '(GMT+08:00) 퍼스'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) 타이베이'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) 오사카, 삿포로, 도쿄'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) 서울'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) 야쿠츠크'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) 애들레이드'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) 다윈'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) 브리즈번'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) 캔버라, 멜버른, 시드니'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) 괌, 포트모르즈비'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) 호바트'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) 블라디보스토크'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) 마가단, 솔로몬 제도, 뉴 칼레도니아'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) 오클랜드, 웰링턴'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) 피지, 캄차카, 마샬 제도'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) 누쿠알로파'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) 아조레스'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) 까뽀베르데 제도'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) 브라질리아'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) 부에노스아이레스, 조지타운'},
    {value: 'America/St_Johns', label: '(GMT-03:30) 뉴펀들랜드'},
    {value: 'America/Halifax', label: '(GMT-04:00) 대서양 시간(캐나다)'},
    {value: 'America/Puerto_Rico', label: '(GMT-04:00) 푸에르토리코, ECT'},
    {value: 'America/Santiago', label: '(GMT-04:00) 산티아고'},
    {value: 'America/Caracas', label: '(GMT-04:30) 카라카스'},
    {value: 'America/Bogota', label: '(GMT-05:00) 보고타, 리마, 키토'},
    {value: 'America/New_York', label: '(GMT-05:00) 동부 표준시(미국 및 캐나다)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) 인디애나(동부)'},
    {value: 'America/Chicago', label: '(GMT-06:00) 중부 표준시(미국 및 캐나다)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) 멕시코시티'},
    {value: 'America/Phoenix', label: '(GMT-07:00) 애리조나'},
    {value: 'America/Denver', label: '(GMT-07:00) 산지 표준시(미국 및 캐나다)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) 태평양 표준시(미국 및 캐나다), 티후아나'},
    {value: 'America/Anchorage', label: '(GMT-09:00) 알래스카'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) 하와이'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) 미드웨이 아일랜드, 사모아'},
  ],
  pt_BR: [
    {value: 'Africa/Casablanca', label: '(GMT) Casablanca, Monróvia'},
    {value: 'Europe/London', label: '(GMT) Dublim, Edimburgo, Lisboa, Londres'},
    {value: 'GMT', label: '(GMT) Greenwich Mean Time'},
    {value: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdã, Berlim, Berna, Roma, Estocolmo, Viena'},
    {value: 'Europe/Belgrade', label: '(GMT+01:00) Belgrado, Bratislava, Budapeste, Liubliana'},
    {value: 'Europe/Brussels', label: '(GMT+01:00) Bruxelas, Copenhague, Madri, Paris'},
    {value: 'Europe/Prague', label: '(GMT+01:00) Praga'},
    {value: 'Europe/Warsaw', label: '(GMT+01:00) Saraievo, Skopje, Sófia, Vilnius, Varsóvia, Zagreb'},
    {value: 'Africa/Malabo', label: '(GMT+01:00) África Centrall'},
    {value: 'Europe/Athens', label: '(GMT+02:00) Atenas, Istambul, Minsk'},
    {value: 'Europe/Bucharest', label: '(GMT+02:00) Bucareste'},
    {value: 'Africa/Cairo', label: '(GMT+02:00) Cairo'},
    {value: 'Africa/Harare', label: '(GMT+02:00) Harare, Pretória'},
    {value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinque, Riga, Tallinn'},
    {value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalém'},
    {value: 'Asia/Baghdad', label: '(GMT+03:00) Bagdá'},
    {value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riad'},
    {value: 'Europe/Moscow', label: '(GMT+03:00) Moscou, S. Petersburgo, Volgogrado'},
    {value: 'Africa/Nairobi', label: '(GMT+03:00) Nairóbi'},
    {value: 'Asia/Tehran', label: '(GMT+03:30) Teerã'},
    {value: 'Asia/Muscat', label: '(GMT+04:00) Abu Dhabi, Mascate'},
    {value: 'Asia/Tbilisi', label: '(GMT+04:00) Baku, Tbilisi, Ierevan'},
    {value: 'Asia/Kabul', label: '(GMT+04:30) Cabul'},
    {value: 'Asia/Yekaterinburg', label: '(GMT+05:00) Ecaterimburgo'},
    {value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi, Tashkent'},
    {value: 'Asia/Calcutta', label: '(GMT+05:30) Calcutá, Chennai, Mumbai, Nova Déli'},
    {value: 'Asia/Katmandu', label: '(GMT+05:45) Catmandu'},
    {value: 'Asia/Novosibirsk', label: '(GMT+06:00) Almaty, Novosibirsk'},
    {value: 'Asia/Dhaka', label: '(GMT+06:00) Astana, Dhaka'},
    {value: 'Asia/Colombo', label: '(GMT+06:00) Sri Jayawardenepura'},
    {value: 'Asia/Rangoon', label: '(GMT+06:30) Yangon'},
    {value: 'Asia/Bangkok', label: '(GMT+07:00) Bangcoc'},
    {value: 'Asia/Jakarta', label: '(GMT+07:00) Hanói, Jacarta'},
    {value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk'},
    {value: 'Asia/Shanghai', label: '(GMT+08:00) Pequim, Chongqing, Hong Kong, Urumqi'},
    {value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk, Ulan Bator'},
    {value: 'Asia/Singapore', label: '(GMT+08:00) Kuala Lumpur, Cingapura'},
    {value: 'Australia/Perth', label: '(GMT+08:00) Perth'},
    {value: 'Asia/Taipei', label: '(GMT+08:00) Taipé'},
    {value: 'Asia/Tokyo', label: '(GMT+09:00) Osaka, Sapporo, Tóquio'},
    {value: 'Asia/Seoul', label: '(GMT+09:00) Seul'},
    {value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk'},
    {value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide'},
    {value: 'Australia/Darwin', label: '(GMT+09:30) Darwin'},
    {value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane'},
    {value: 'Australia/Sydney', label: '(GMT+10:00) Camberra, Melbourne, Sydney'},
    {value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby'},
    {value: 'Australia/Hobart', label: '(GMT+10:00) Hobart'},
    {value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok'},
    {value: 'Asia/Magadan', label: '(GMT+11:00) Magadan, Ilhas Salomão, Nova Caledônia'},
    {value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington'},
    {value: 'Pacific/Fiji', label: '(GMT+12:00) Fiji, Kamchatka, Ilhas Marshall'},
    {value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nukualofa'},
    {value: 'Atlantic/Azores', label: '(GMT-01:00) Açores'},
    {value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Ilhas de Cabo Verde'},
    {value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasília'},
    {value: 'America/Buenos_Aires', label: '(GMT-03:00) Buenos Aires, Georgetown'},
    {value: 'America/St_Johns', label: '(GMT-03:30) Newfoundland'},
    {value: 'America/Halifax', label: '(GMT-04:00) Horário do Atlântico (Canadá)'},
    {value: 'America/Puerto_Rico', label: '(GMT-04:00) Porto Rico, ECT'},
    {value: 'America/Santiago', label: '(GMT-04:00) Santiago'},
    {value: 'America/Caracas', label: '(GMT-04:30) Caracas'},
    {value: 'America/Bogota', label: '(GMT-05:00) Bogotá, Lima, Quito'},
    {value: 'America/New_York', label: '(GMT-05:00) Horário do Leste (EUA e Canadá)'},
    {value: 'America/Indianapolis', label: '(GMT-05:00) Indiana (Leste)'},
    {value: 'America/Chicago', label: '(GMT-06:00) Horário Central (EUA e Canadá)'},
    {value: 'America/Mexico_City', label: '(GMT-06:00) Cidade do México'},
    {value: 'America/Phoenix', label: '(GMT-07:00) Arizona'},
    {value: 'America/Denver', label: '(GMT-07:00) Horário das Montanhas (EUA e Canadá)'},
    {value: 'America/Los_Angeles', label: '(GMT-08:00) Horário do Pacífico (EUA e Canadá); Tijuana'},
    {value: 'America/Anchorage', label: '(GMT-09:00) Alasca'},
    {value: 'Pacific/Honolulu', label: '(GMT-10:00) Havaí'},
    {value: 'Pacific/Samoa', label: '(GMT-11:00) Ilha Midway, Samoa'},
  ],
};

export const timeZoneOptions = (locale) => (timeZones[locale] || timeZones.en_US);
